const chatMessage = {
  title: 'Click.AI',
  copyMessage: '¡Texto copiado con éxito!',
  copyError: '¡Error al copiar el texto!',
  chatSessionError: 'Error al iniciar la sesión con Click.AI.',
  helpPrompt: {
    title: '¿Cómo puedo ayudarte hoy?',
    firstSteps: 'Guía de primeros pasos',
    template: {
      whatIs: '¿Qué es una plantilla?',
      howToCreate: '¿Cómo crear una plantilla?',
    },
    formFlow: {
      whatIs: '¿Qué es un flujo con formulario?',
      howToCreate: '¿Cómo crear un flujo con formulario?',
    },
    pendingAnswers: {
      whatIs: '¿Qué son las respuestas pendientes?',
    },
    spreadsheetFlows: {
      whatIs: '¿Qué es un flujo de hoja de cálculo?',
      howToCreate: '¿Cómo crear un flujo de hoja de cálculo?',
    },
    compliance: {
      whatIs: '¿Qué es la aprobación de respuestas?',
    },
  },
  footer: {
    input: {
      placeholder: 'Habla con Click.AI',
    },
    help: {
      text: '¿Aún tienes dudas? Visita nuestra',
      link: 'Central de Ayuda',
    },
  },
};

export default chatMessage;
